//import { host_service } from './environment.prod';
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const host_service = {
  host: "http://localhost:8080/ema-admin/v1/ema-system/",//No se usa
  hostAutorize: "https://6bsc128mm6.execute-api.us-east-2.amazonaws.com/ema-authorization/v1/",
  hostEmaCustomers: "https://yskfrn7xul.execute-api.us-east-2.amazonaws.com/test/",
  hostEmaAdmin: "https://i60kxd3lbl.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostEmaAdmin2: "https://ymvnnflgq2.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostEmaAdmin3: "https://st10ywpjjb.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostEmaAdmin4: "https://kt0jkxwpd8.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostSecurity: "https://mebgjnr8zg.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/",
  hostSecurityCustomers: "https://0xd5lqab4h.execute-api.us-east-2.amazonaws.com/prod/emaadmin-api/v1/customers/",
  hostEmaApp: "https://igd9lneez1.execute-api.us-east-1.amazonaws.com/emaAdmin/",
  admin: "administration/",


};
export const environment = {
  production: false,
  ambiente: "prod-file",
  descrpcion_ambiente: "",
  version_app: "V1.0.0",
  api: {
    //NO SE USAN PERO ESTAN EN FUNCIONES 
    refreshToken:
          host_service.host  + "both/ema-admin/refresh-token",
          readQuotationGroupService:host_service.host +"customers/quotation-v1/group-services/",
          get_customer_data: host_service.host + "customers/",
          get_wo_employees: host_service.host + "contract/work-orders/employees",
          get_associated_service: host_service.host + "contract/catalogs/associated-services-types",
          create_schedulle_eventual_service: host_service.host +  "customers/contract/service-scheduling/eventual-service",
          addContractGroupServices:host_service.host  +"customers/contract/group-services/", /////NO se utilizará
          get_contract_status:host_service.host +"customers/contract/general-data/status",
          getCatalogActivitiesElements:host_service.host + "contract/services/elements-v1/", /////NO se utilizará
          getCatalogActivitiesGroup:host_service.host  + "catalog/activities-group",
          email_attachment_service:host_service.hostEmaAdmin + "/send/email",
          employeesGet: host_service.host + "v1/employees/",
          quotationStatusGet: host_service.host + "catalogs/quotations-status", /////NO se utilizará
          getIndustries:host_service.host + "ema-admin/catalogs/industries", /////NO se utilizará
          prospectosPorCategoria:host_service.host + "v1/ema-admin/prospects",
    //////

    
        login_LF_V1: host_service.hostAutorize + "token",
        menu_LF_V1: host_service.hostSecurity + "menu",
        logout_v1: host_service.hostAutorize + "logout/",
        notificationsNewPassword: host_service.hostEmaCustomers + "send/notifications-new-password",
        tokenTemp: host_service.hostAutorize + "tokenTemp",
    
        //App
        service_report: host_service.hostEmaApp + "api/v1/serviceReport",
        work_order_sup: host_service.hostEmaApp + "dev/workOrder",
        updateWorkOrderSUp: host_service.hostEmaApp + "api/v1/workOrder",
        workOrder: host_service.hostEmaApp + "dev/workOrder",
        devices_monitoring_get: host_service.hostEmaApp + "api/v1/service-report/monitoring-devices",
        devices_monitoring_upsert: host_service.hostEmaApp + "api/v1/serviceReport/deviceMonitoring",
    
        //catalogs.yml
        get_catalogs_LF_V1: host_service.hostEmaAdmin + "ema-general/catalogs-v1",
        getCountries_LF_V1: host_service.hostEmaAdmin + "catalogs/countries",
        getStates_LF_V1: host_service.hostEmaAdmin + "catalogs/states",
        getCities_LF_V1: host_service.hostEmaAdmin + "catalogs/cities",
        material_chemical: host_service.hostEmaAdmin + "materials-chemical",
        activitiesConfiguration: host_service.hostEmaAdmin + "services/activities/configuration",
        sendWhatsApp: host_service.hostEmaAdmin + "send/whats-app-message",
        getZones: host_service.hostEmaAdmin + "catalogs/zones",
        getRoutes: host_service.hostEmaAdmin + "catalogs/routes",
        get_catalogs_LF_V2: host_service.hostEmaAdmin + "ema-general/catalogs-v2",
    
    
        //customers.yml
        client_service: host_service.hostEmaAdmin + "customers",
        customers_LF_V1: host_service.hostEmaAdmin + "customers",//Probable eliminacion
        getBranchesByCustomerID_LF_V1: host_service.hostEmaAdmin + "customers-branches", //Probable eliminacion
        branches_client_service: host_service.hostEmaAdmin + "customers-branches",
        branches_client_all: host_service.hostEmaAdmin + "customers-branches/all ",
        eventualID: host_service.hostEmaAdmin + "customers/eventual",
    
    
        //company.yml
        company: host_service.hostEmaAdmin + "company",
        companyBranches: host_service.hostEmaAdmin + "company/branches",
    
    
    
        //contract.yml
        getContractActivitiesElementsV1_LF_V1: host_service.hostEmaAdmin + "contract/services/elements-v1/",
        readactivitiesConfiguration: host_service.hostEmaAdmin + "contract/services/activities/configuration",
        getContractList_LF_V1: host_service.hostEmaAdmin + "customers/contract/general-data",//Cambiar solo por contract
        upsertContract_LF_V1: host_service.hostEmaAdmin + "customers/contract/general-data",//Posible Eliminacion
        contract_ind: host_service.hostEmaAdmin + "customers/contract/individual",
        getContractBranches_LF_V1: host_service.hostEmaAdmin + "customer-branches/contract/",//CambiarNombre
        add_customer_branches_contract_LF_V1: host_service.hostEmaAdmin + "customer-branches/contract",//Posible Eliminacion
        getContractGroupServices_LF_V1: host_service.hostEmaAdmin + "customers/contract/group-services",//Cambiar nombre
        deleteContractGroupServices_LF_V1: host_service.hostEmaAdmin + "customers/contract/group-services/",//Posible
        add_group_services_Lambda_V1: host_service.hostEmaAdmin + "customers/contract/group-services",//Posible
        updateGroup_service: host_service.hostEmaAdmin + "customers/contract/update/group-services",
        get_activity_to_contract_LF_V1: host_service.hostEmaAdmin + "contract/services-v1/activities",//Cambiar
        add_activity_to_contract_LF_V1: host_service.hostEmaAdmin + "contract/services-v1/activities",//Posible
        delete_activity_to_contract_LF_V1: host_service.hostEmaAdmin + "contract/services-v1/activities",//Posible
        getassociated_service_by_group_service_LF_V1: host_service.hostEmaAdmin + "contract/associated-services/",//Cambiar
        upsert_contract_associated_service_LF_V1: host_service.hostEmaAdmin + "contract/associated-services",//Posible
        deleteAssocService: host_service.hostEmaAdmin + "contract/associated-services/",//posible
        get_supervisor_and_technical_list_LF_V1: host_service.hostEmaAdmin + "employees/data",//cambiar
        get_service_scheduling_LF_V1: host_service.hostEmaAdmin + "customers/contract/service-scheduling",//Cambiar
        create_schedulle_LF_V1: host_service.hostEmaAdmin + "customers/contract/service-scheduling",//Posible
        file_maps_service: host_service.hostEmaAdmin + "customers/contract/maps",
        servicesDetail: host_service.hostEmaAdmin + "customers/contract/service-scheduling/detail",
        payment_form_contract: host_service.hostEmaAdmin + "contract/payment-form",
        get_g_s_for_sociated_service_LF_V1: host_service.hostEmaAdmin + "customers/contract/group-services-associated-service/",
        contract_collections:host_service.hostEmaAdmin +   "customers/contract/collection-date",
    
    
        //devicesAdmin.yml
        devices_service: host_service.hostEmaAdmin2 + "devices",
        updateDevice: host_service.hostEmaAdmin2 + "devices/update",//Posible
        deviceMonitoring: host_service.hostEmaAdmin2 + "device-monitoring",
        deviceManagement: host_service.hostEmaAdmin2 + "device-management",
    
    
        //employees.yml
        Employees_LAMBDA_V1: host_service.hostEmaAdmin2 + "employees",
        driverLicenses: host_service.hostEmaAdmin2 + "drivers",
        documentEmployees: host_service.hostEmaAdmin2 + "employees/documents",
        upseremployee:host_service.hostEmaAdmin2  + "employees",
    
        //prospects.yml
        prospectosPorCategoria_LF_V1: host_service.hostEmaAdmin2 + "prospects",
        prospectToClient: host_service.hostEmaAdmin2 + "prospect-client",
        prospections_services: host_service.hostEmaAdmin2 + "prospections",
        prospection_letter_service: host_service.hostEmaAdmin2 + "prospections/letter",
        prospection_meeting_service: host_service.hostEmaAdmin2 + "prospections/meeting",
    
    
        //quotations.yml
        getQuotationListByProspectID_LF_V1: host_service.hostEmaAdmin2 + "quotations/",//Cambiar
        quotationCreation_LF_V1: host_service.hostEmaAdmin2 + "quotations-upsert",
        deleteQuotation_LF_V1: host_service.hostEmaAdmin2 + "quotations",//posible
        getQuotationByFilter: host_service.hostEmaAdmin2 + "quotationsbyfilter",
        Quotation_Devices_LAMBDA_V1: host_service.hostEmaAdmin2 + "customers/quotation-v1/devices",
        QuotationGroupService_LAMBDA_V1: host_service.hostEmaAdmin2 + "customers/quotation-v1/group-services",
        QuotationHasServicePlace_LAMBDA_V1: host_service.hostEmaAdmin2 + "quotation/service-places",
        QuotationHasSalesTypes_LAMBDA_V1: host_service.hostEmaAdmin2 + "quotation/sales-type",
        Quotation_Credit_Days_LAMBDA_V1: host_service.hostEmaAdmin2 + "quotation/credit-days",
        Quotation_Payment_Form_LAMBDA_V1: host_service.hostEmaAdmin2 + "quotation/payment-form",
        Quotation_Service_Frecuency_LAMBDA_V1: host_service.hostEmaAdmin2 + "quotation/service-frequency",
        QuotationActivities_LAMBDA_V1: host_service.hostEmaAdmin2 + "customers/quotation-v1/activities",
        quotationprospectToClient: host_service.hostEmaAdmin2 + "quotation/prospect-client",
        quotationHasPest: host_service.hostEmaAdmin2 + "customers/quotation-v1/pest",
        quotationHasRequirements: host_service.hostEmaAdmin2 + "customers/quotation-v1/requirement",
        quotationHasSpecialTreatments: host_service.hostEmaAdmin2 + "customers/quotation-v1/special-treat",
        quotationHasAreas: host_service.hostEmaAdmin2 + "customers/quotation-v1/areas",
        QuotationProspectClientInfo: host_service.hostEmaAdmin2 + "quotation/prospect/client/info/",
    
        //work-order.yml
        GetTechnical_LF_V1: host_service.hostEmaAdmin3 + "work-order/tecnical",
        get_wo_employees_data_LF_V1: host_service.hostEmaAdmin3 + "work-orders/employees",
        post_wo_employees_data_LF_V1: host_service.hostEmaAdmin3 + "work-orders/employees",//Posible
        create_schedulle_individual_service_LF_V1: host_service.hostEmaAdmin3 + "customers/contract/individual-work-order-schedulling",
        delete_wo_employees_data_LF_V1: host_service.hostEmaAdmin3 + "work-order-employee",
        deleteWorkOrder: host_service.hostEmaAdmin3 + "work-order",
        checkStatusWorkOrder: host_service.hostEmaAdmin3 + "work-order/status",
        workOrdersInformation: host_service.hostEmaAdmin3 + "collections/schedule",
        workOrderBilled: host_service.hostEmaAdmin3 + "work-order/billed",
        eventualServicesForBranch: host_service.hostEmaAdmin3 + "work-orders/eventual/branch",
        eventualServices: host_service.hostEmaAdmin3 + "work-orders/eventual",
        workOrderreport: host_service.hostEmaAdmin3 + "work-order/report/",
        inspectionService: host_service.hostEmaAdmin3 + "service-report/inspection",
        workOrderCalendar:host_service.hostEmaAdmin3 +"work-orders/calendar",
      
    
    
    
        //sales-doc.yml
        salesDocumentHasServices: host_service.hostEmaAdmin3 + "sales-doc/services",
        salesDocument: host_service.hostEmaAdmin3 + "sales-doc",
    
        //service-area.yml
        areas_service: host_service.hostEmaAdmin3 + "service/area",
    
        //collection-schedull.yml
        collectionSchedule: host_service.hostEmaAdmin4 + "collection/schedull",
        
    
        //vehicles.yml
        driversVehicles: host_service.hostEmaAdmin4 + "drivers/vehicles",
        vehiclesAdmin: host_service.hostEmaAdmin4 + "vehicles/get",
    
    
    
        //security
    
        //users.yml
        user_service: host_service.hostSecurity + "user",
        UserAdmin: host_service.hostSecurity + host_service.admin + "user",
        UserRolesAdmin: host_service.hostSecurity + host_service.admin + "user/roles",
        checkUserInformation: host_service.hostSecurity + "user/exist",
        system_config_user_service: host_service.hostSecurity + "user",
        employeeUserData:host_service.hostSecurity + "employee/user",
    
        //roles.yml
        RolesAdmin: host_service.hostSecurity + host_service.admin + "roles",
        RolesPagesAdmin: host_service.hostSecurity + host_service.admin + "roles/pages",
        RolesLabelsAdmin: host_service.hostSecurity + host_service.admin + "roles/labels",
        system_config_roles_service:host_service.hostSecurity+"administration/roles",
        system_config_roles_labels_service:host_service.hostSecurity+"administration/roles/labels",
        system_config_roles_pages_service:host_service.hostSecurity +"administration/roles/pages",
    
    
        //pages.yml
        PagesAdmin: host_service.hostSecurity + host_service.admin + "pages",
        PagesLabelsAdmin: host_service.hostSecurity + host_service.admin + "pages/labels",
        system_config_pages_service:host_service.hostSecurity +"administration/pages",
        system_config_pages_labels_service: host_service.hostSecurity + "administration/pages/labels",
    
    
        //temp-url.yml
        tempUrl: host_service.hostSecurity + "temp-url",
    
        //Companies.yml
        companySecurity: host_service.hostSecurity + "/security/company",
        system_config_companies_service: host_service.hostSecurity + "companies",
        system_config_comany_branches_service: host_service.hostSecurity + "companies/branch",
    
        //security-emaCustomers
        //form-control.yml
        formControlService:host_service.hostSecurityCustomers+"form_control/id",
        formControlPageOptionsService:host_service.hostSecurityCustomers+"form_control_page_options",
    
        //languages.yml
        languagesService:host_service.hostSecurityCustomers+"languages",
    
        //modules.yml
        modulesService:host_service.hostSecurityCustomers+"modules",
    
        //pages.yml
        pagesLabelsService:host_service.hostSecurityCustomers+"pages_labels",
        pagesOptionsLabelsService:host_service.hostSecurityCustomers+"page_options_labels",
        pagesOptionsService:host_service.hostSecurityCustomers+"page_options",
        pagesService:host_service.hostSecurityCustomers+"pages_pages",
    
        //roles.yml
        rolesPagesService:host_service.hostSecurityCustomers+"roles_pages",
        rolesService:host_service.hostSecurityCustomers+"roles",
        rolesLabelsService:host_service.hostSecurityCustomers+"roles_labels",
    
    
    
    
    
      },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
